const apiUrl = process.env.REACT_APP_API_URL;
export const PostIngredientsPlat = async ( id_plat : number, id_ingredient : number, qInfantil : number, qPrimaria : number, qAdult : number, per100 : number, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/plats/ingredients`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ id_plat, id_ingredient, qInfantil, qPrimaria, qAdult, per100 })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};